import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = {
  key: 1,
  class: "date-field-h"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" h ")
const _hoisted_5 = {
  key: 2,
  class: "date-field-h-m"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("h ")
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("min ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.format == 'date')
    ? (_openBlock(), _createElementBlock("input", {
        key: 0,
        type: "date",
        value: _ctx.formatDate(_ctx.value),
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDateUpdated($event)))
      }, null, 40, _hoisted_1))
    : (_ctx.format == 'time:h')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("input", {
            type: "number",
            min: "0",
            value: _ctx.value,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onHoursUpdated($event))),
            placeholder: "0",
            onFocusin: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onNumberFocusIn && _ctx.onNumberFocusIn(...args))),
            onFocusout: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onNumberFocusOut && _ctx.onNumberFocusOut(...args)))
          }, null, 40, _hoisted_3),
          _hoisted_4
        ]))
      : (_ctx.format == 'time:h:m')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("input", {
              type: "number",
              min: "0",
              value: _ctx.value?.split(':')[0],
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onHoursUpdated($event))),
              placeholder: "00",
              onFocusin: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onNumberFocusIn && _ctx.onNumberFocusIn(...args))),
              onFocusout: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onNumberFocusOut && _ctx.onNumberFocusOut(...args)))
            }, null, 40, _hoisted_6),
            _hoisted_7,
            _createElementVNode("input", {
              type: "number",
              min: "0",
              value: _ctx.value?.split(':')[1],
              onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onMinutesUpdated($event))),
              placeholder: "00",
              onFocusin: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onNumberFocusIn && _ctx.onNumberFocusIn(...args))),
              onFocusout: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onNumberFocusOut && _ctx.onNumberFocusOut(...args)))
            }, null, 40, _hoisted_8),
            _hoisted_9
          ]))
        : _createCommentVNode("", true)
}